import { initialState } from "../locations.slice";

const resetLocations = () => {
    return initialState;
}

export default resetLocations;